import React, { useEffect, useRef } from "react";
import "./ModalShell.css";

export default function ModalShell({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,

  closeOnOverlay = true,
  closeOnEsc = true,

  // "sm" | "md" | "lg" | "xl"
  size = "md",

  // UI
  showClose = true,
  headerRight, // например: <Badge/> <Button/>
}) {
  const overlayRef = useRef(null);
  const dialogRef = useRef(null);

  // ESC + focus + body scroll lock
  useEffect(() => {
    if (!open) return;

    // lock scroll
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    // focus dialog
    const t = setTimeout(() => dialogRef.current?.focus?.(), 0);

    const onKeyDown = (e) => {
      if (!closeOnEsc) return;
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      clearTimeout(t);
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, closeOnEsc, onClose]);

  if (!open) return null;

  const sizeClass =
    size === "sm"
      ? "ms--sm"
      : size === "lg"
      ? "ms--lg"
      : size === "xl"
      ? "ms--xl"
      : "ms--md";

  const handleOverlayMouseDown = (e) => {
    if (!closeOnOverlay) return;
    // закрываем только если кликнули прямо по overlay, а не по дочерним
    if (e.target === overlayRef.current) onClose?.();
  };

  return (
    <div
      ref={overlayRef}
      className={`ms-overlay ${sizeClass}`}
      onMouseDown={handleOverlayMouseDown}
      role="presentation"
    >
      <div
        ref={dialogRef}
        className="ms-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={title || "Modal"}
        tabIndex={-1}
      >
        {(title || subtitle || showClose || headerRight) && (
          <div className="ms-header">
            <div className="ms-header__text">
              {title ? <h3 className="ms-title">{title}</h3> : null}
              {subtitle ? <div className="ms-subtitle">{subtitle}</div> : null}
            </div>

            <div className="ms-header__right">
              {headerRight ? <div className="ms-header__slot">{headerRight}</div> : null}

              {showClose ? (
                <button
                  type="button"
                  className="ms-close"
                  onClick={onClose}
                  aria-label="Close"
                  title="Закрыть"
                >
                  <span aria-hidden="true">×</span>
                </button>
              ) : null}
            </div>
          </div>
        )}

        <div className="ms-body">{children}</div>

        {footer ? <div className="ms-footer">{footer}</div> : null}
      </div>
    </div>
  );
}
